module.exports = __webpack_public_path__ + "img/7.fac84446.jpg";